import './_errorBoundary.scss';
import React from 'react';

const CrashPage = () => (
  <div className="error-boundary">
    <div className="error-boundary__text">Oops! Something went wrong...</div>
    <button onClick={() => (window.location.href = '/admin')} className="error-boundary__button">
      Go to
      {' '}
      {'last page'}
    </button>
  </div>
);

export default CrashPage;
